import type { ReactNode } from 'react';
import type { Locale } from '~/lib/i18n';

import { LocaleContext } from '~/lib/localeContext';

/**
 * @param props.locale - Active locale to provide to descendants
 * @param props.children - Subtree that can read the locale via useLocale
 * @returns Provider exposing the active locale through context
 */
export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale;
  children: ReactNode;
}) {
  return <LocaleContext value={locale}>{children}</LocaleContext>;
}
